import React ,{ useState }from "react";

import { Bounce } from 'react-activity';
import 'react-activity/dist/react-activity.css';

import Drawer from '@material-ui/core/Drawer';
import { Table } from "react-bootstrap";

import {getSalesCompare, getMyAccounts,getMaster,getAccounts ,getDpExport} from "../../crud/auth.crud";
import { Link } from "react-router-dom";
import { IconButton,TextField,MenuItem,InputLabel,Select } from '@material-ui/core';
import { Tooltip } from "@material-ui/core";	
//import InfiniteScroll from "react-infinite-scroller";
import SearchIcon from '@material-ui/icons/Search';
import DateFnsUtils from '@date-io/date-fns';
import {  format } from 'date-fns'
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import Grid from '@material-ui/core/Grid';					
import EditIcon from '@material-ui/icons/Edit';		
import Checkbox from '@material-ui/core/Checkbox';
//import PaymentIcon from '@material-ui/icons/Payment';
import DescriptionIcon from '@material-ui/icons/Description';
import ReceiptIcon from '@material-ui/icons/Receipt';

import Button from '@material-ui/core/Button';
//import SaveIcon from '@material-ui/icons/Save';
import Icon from '@material-ui/core/Icon';
 import CodeExample from "../../partials/content/CodeExample";
//import setDisplay from "../../partials/content/CodeExample";
import EditOrderReqStatus from './EditOrderReqStatus'
import FormGroup from '@material-ui/core/FormGroup';




import { Bar,Line } from 'react-chartjs-2';


 
import Autocomplete from '@material-ui/lab/Autocomplete';
//import { ThreeDRotationSharp, TrendingUpOutlined } from "@material-ui/icons";
 import BootstrapTable from 'react-bootstrap-table-next';
 import filterFactory, { textFilter,numberFilter } from 'react-bootstrap-table2-filter';
 import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';
 import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
 import paginationFactory from 'react-bootstrap-table2-paginator'

 import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

 import Alert from '@material-ui/lab/Alert'
 
 
 import CircularProgress from '@material-ui/core/CircularProgress';
import { Portlet, PortletBody, PortletHeader } from "../../partials/content/Portlet";







//import Moment from 'moment';

const yearOptions = {
	responsive: true,
    maintainAspectRatio: true,
  legend: {
        display: false
    },
  scales: {
	xAxes: [{
                barThickness: 25,  // number (pixels) or 'flex'
                maxBarThickness: 30 // number (pixels)
            }],
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
        },
      },
    ],
  },
};
 

export default class WalletReport extends React.Component {

	defaultSorted = [{
		dataField: 'month',
		order: 'desc'
	  }];
	
	  columns = [
		{
		  dataField: 'productCode',
		  text: 'Item#',
		  width: 150,
		  sort: false,
		  
		},
		{
		  dataField: 'productName',
		  text: 'Description',
		  width: 150,
		  sort: false,
		  
		},
	 	{
		  dataField: 'minStocksHold',
		  text: 'Min Stocks to hold',
		  width: 150,
		  sort: false,
		  
		},
		{
		  dataField: 'maxStocksHold',
		  text: 'Max Stocks to hold',
		  sort:false
		 
		},
		{
		  dataField: 'currentStocks',
		  text: 'Stock on hand',
		  sort:false
		 
		}	,
		{
		  dataField: 'procedures',
		  text: 'Staged Inventory',
		  sort:false
		 
		},
		{
		  dataField: 'requirement',
		  text: 'Requirement',
		  sort:false
		 
		}
		,
		{
		  dataField: 'percent',
		  text: 'Nobel Order %',
		  sort:false
		 
		}
	  ];
 
  handleDateChange = (date) => {
    this.setState({selectedDate : date});
  };

  state = {
    schedules:[],
    pRights:[],
    hasMoreItems:false,
    page:1,
        isReset:false,

    isLoading:false,
        filterFields :{},
    fields:[],
    filter:false,
    selectedDate:null,
    open:false,
    notes:[],
    notesId:'',
    statusSettings:
        "JOBS00003"
    ,
    postObj:{},
	statusFilter:null,
	selectedDrawerItem:null,
	invoiceDrawerOpen:false,
	invoiceViewDrawerOpen:false,
	jobServiceTypes:[],
	permission:[],
	columns :this.columns,
    defaultSorted: this.defaultSorted,
	tableData:[],
	entity:[],
    accounts:[],
    businessEntity:'',
    selaccount:null,
	lookUp: {product:'productKey',account:'accountKey'},
	groupBy: [],
	reportBy:[],
	dateCreatedTo:null,
	dateCreatedFrom:null,
	isSalesYearLoading:false,
	salesYear:null,

  }

 constructor(props)
{
	super(props);


}




resetFilter()
{
	let postObj={};
  		//this.state.filter=false;
  		  		this.setState({isReset:false});
  		  		
  		  		this.setState({filter:false},function(){
					this.setState({filter:true})		
  		  		})
				
  		  		
  	 	this.state.fields[0].fields.map((field)=> {
  			
  			this.state[`Filter_${field.fieldName}`]=null;

 
  			})
}

	reserFilterText()
	{
		this.setState({filter:true})
	}

   handleReset(event)
  {
  		let postObj={};
  		//this.state.filter=false;
  		  		this.setState({isReset:true});
  		  		
  		  		this.setState({filter:false},function(){
					this.setState({filter:true})		
  		  		})
				
  		  		
  	 	this.state.fields[0].fields.map((field)=> {
  			
  			this.state[`Filter_${field.fieldName}`]=null;
			if(field.dataType==='autocomplete')
			{
				this.setState({[field.fieldName]:[],[`Filter_${field.fieldName}`]:''});
				
			}
 
  			})

  			this.setState({activePage:1})
			  
  }

  
 async componentDidMount()
  {
 
  
	//this.setState({isLoading:true});

	/* await getMaster('entity')
								.then((response)=>
									{
										//console.log('Master :',fieldMap.fieldName);
										//alert(fieldMap.fieldName);
										this.setState({entity:response.data});
								
	
	
									})
	
					await getMyAccounts().then((response)=>{
					  this.setState({accounts:response.data});
					})
*/
   

  	this.setState({hasMoreItems:false,isLoading:false,isSalesYearLoading:true});
  	

    let postObj={};
			
  	

   /*getSalesCompare("month",'product',postObj)//.then(response => response.data)
    .then((response) => {
      this.setState({isLoading:false});
      this.setState({ tableData: response.data});
     
     })


*/

			 let salesyrdata = {
			labels: ['Min Stock', 'Total Stock','Max Stock'],
			datasets: [
			  {
			   // label: ['Min Stock', 'Total Stock','Max Stock'],
				data: [20,198,40],
				backgroundColor: ["#f7611b","#75f71b","#f7f41b"],
				fill:false,
				borderWidth: 0,
			  }
			  
			  ],
			};


			this.setState({isSalesYearLoading:false,salesYear:salesyrdata});
		   

  }
 


handleChangeEntity=(event)=>
 {
   

    this.setState({businessEntity:event.target.value});
  }

  handleChangeAccount=(event)=>
  {
    console.log(event);
    this.setState({selaccount:event.target.value});
	
    
  }
 

    handleFilter(event)
	{
   
	   this.setState({isLoading:true})
	   let params = {};
	   if(this.state.selaccount!==null && this.state.selaccount!=="")
	   {
			console.log(this.state.selaccount);
			params.accountKey = this.state.selaccount;
		 
	   
			if(this.state.dateCreatedFrom!==null && this.state.dateCreatedFrom!=="")
			{
					console.log(this.state.dateCreatedFrom);
					let formattedDate=format(this.state.dateCreatedFrom, 'yyyy-MM-dd');
					params.datefromcreatedOn = formattedDate;
			}

			if(this.state.dateCreatedTo!==null && this.state.dateCreatedTo!=="")
			{
					console.log(this.state.dateCreatedTo);
					let formattedDate=format(this.state.dateCreatedTo, 'yyyy-MM-dd');
					params.datetocreatedOn = formattedDate;
			}
			let group = this.state.groupBy.toString();
					if(this.state.groupBy.toString()==="") group="month"; 

				getSalesCompare(group,this.state.reportBy.toString(),params)//.then(response => response.data)
				.then((response) => {
						this.setState({isLoading:false})
						this.setState({ tableData: response.data,columns:this.state.columns,postObj:params})
			
					})
		
	   }
	   else
	   {
		this.setState({isLoading:false});
	   }
   
	 }

	autocompleteOnChange=(event,newValue,fieldName,lookupKey) => {
		if(event!==null && newValue!==null)
		{
		  console.log("autocomplete change:::",event ,newValue,fieldName,lookupKey,newValue[lookupKey]);
		  this.setState({[fieldName]:newValue[lookupKey]});
		}
		
	  }
	
 handleGroupByChange = (event) => {
	let groupFields = this.state.groupBy;
	let index = groupFields.findIndex((x)=> x===event.target.value);
	console.log("inde::::",index);
	if(index<0)
		groupFields.push(event.target.value)
	else
		groupFields.splice(index,1)

	console.log(groupFields);

    this.setState({isLoading:true,groupBy: groupFields});

    let tableColumns = [];
	groupFields.map((f)=>{
		tableColumns.push({
		 dataField: f,
		  text: f,
		  width: 150,
		  sort: false,
	});
	})
	this.state.reportBy.map((f)=>{
		tableColumns.push({
			dataField: this.state.lookUp[f],
			text: f,
			width: 150,
			sort: false,
		});
	})
	
	tableColumns.push({
		dataField: 'total',
		  text: 'Sales',
		  sort:false
	});
	 
	 getSalesCompare(groupFields.toString(),this.state.reportBy.toString(),this.state.postObj)//.then(response => response.data)
    .then((response) => {
      this.setState({isLoading:false})
      this.setState({ tableData: response.data,columns:tableColumns})
     
     })
  };


   handleReportByChange = (event) => {
	
	let reportFields = this.state.reportBy;
	let index = reportFields.findIndex((x)=> x===event.target.value);
	console.log("inde::::",index);
	if(index<0)
		reportFields.push(event.target.value)
	else
		reportFields.splice(index,1)

	console.log(reportFields);

    this.setState({isLoading:true,reportBy: reportFields});
	let tableColumns = [];
	this.state.groupBy.map((f)=>{
		tableColumns.push({
		 dataField: f,
		  text: f,
		  width: 150,
		  sort: false,
	});
	})
	reportFields.map((f)=>{
		tableColumns.push({
			dataField: this.state.lookUp[f],
			text: f,
			width: 150,
			sort: false,
		});
	})		
	
	tableColumns.push({
		dataField: 'total',
		  text: 'Sales',
		  sort:false
	});
	 
	 getSalesCompare(this.state.groupBy.toString(),reportFields.toString(),this.state.postObj)//.then(response => response.data)
    .then((response) => {
      this.setState({isLoading:false})
      this.setState({ tableData: response.data,columns:tableColumns})
     
     })
  };
	  

	 exportClick(event)
	{
	  	let postObj={};
	
	  	this.state.fields[0].fields.map((field)=> {
	  			
	  			if(this.state[`Filter_${field.fieldName}`]!=undefined && this.state[`Filter_${field.fieldName}`]!='' && field.isDummy===false)
	  			{
	  				 if(field.dataType==="lookup")
	  				 	postObj[field.lookUp.lookupKey]=this.state[`Filter_${field.fieldName}`];
					 else if(field.dataType==="autocomplete")
						 postObj[field.lookUp.lookupKey]=this.state[`Filter_${field.fieldName}`];
	  				 else if (field.dataType==="date")
	  				 {
	  				 	//alert(field.fieldName+' : '+this.state[`Filter_${field.fieldName}`]);
	  				 	let varSelectedDate=this.state[`Filter_${field.fieldName}`]
	  				 	let formattedDate=format(varSelectedDate, 'yyyy-MM-dd')
	  				 	//const formattedDate = varSelectedDate.getFullYear()+'-'+(varSelectedDate.getMonth()+1)+'-'
	  				 	//+varSelectedDate.getDate();
	  				 	//alert(formattedDate);
	  				 	postObj[field.fieldName]=formattedDate;
	  				 }
					   else if(field.dataType==="dropdown")
						{	  				 	
							postObj['cdnbool'+field.fieldName]=this.state[`Filter_${field.fieldName}`].toString();
						}
	  				 else
	  				 {
	  				 	
	  				 	postObj[field.fieldName]=this.state[`Filter_${field.fieldName}`];
	  				 }
	  			}

	  			}) 
	  		   
	  		    getDpExport(postObj)
					    .then((response) => {
					      if(response.data!=""){
					    	var win = window.open(response.data, '_blank');
  							win.focus();}
  							else
  								alert('Error exporting records')
					    })
	}

  render() {
  	//console.log("schedule::::",this.state.schedule);
    return (
      <>

        <div className="row">
				<div className= "col-md-12">
					<Portlet>
						<PortletHeader title="Wallet Comparison Report"></PortletHeader>
					</Portlet>
				</div>
			</div>

      	<div className="row">

          	
            {<div className="col-lg-12">
						  
							<div className="kt-portlet kt-portlet--height-fluid">
							 <div className="kt-portlet__head">
							   <div className="kt-portlet__head-label">
								 <h3 className="kt-portlet__head-title">Stock Threshold</h3>
							   </div>
							  
							 </div>
							 <div className="kt-portlet__body">
							   {this.state.salesYear!==null &&
								 <Bar ref={this.chartReference}  data={this.state.salesYear} options={yearOptions} />
							   }
							   {this.state.isSalesYearLoading &&
									   <div style={{alignItems: "center",display: 'flex', justifyContent: 'center'}}>                            
										   <Alert severity="info" icon={<CircularProgress size={15} />}>&nbsp;&nbsp;Loading...</Alert>      
									   </div>
								 }
							 </div>
						   </div>
						   
						   
						 </div>}
          	</div>
        
    
      </>
    );
  }
}
